import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "../components/Home/Home";
import About from "../components/About/About";
import Header from "../components/Header/Header";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const App = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
  }));

  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <Router basename={'react/running-log'}>
        <Header></Header>
        <Switch>
          <Route path="/about" exact component={About} />
          <Route path="/" exact component={Home} />
        </Switch>
      </Router>
    </Container>
  );
};

export default App;
